/* eslint-disable */
var redirectURL = ""

var mapURL = {
  generateToken : "https://au1gis.solutions.arcadis.com/arcgis/sharing/rest/generateToken",
  services: "https://au1gis.solutions.arcadis.com/arcgis/rest/services"
}

if (process.env.NODE_ENV === 'production') {
  // This will be replaced with the server endpoint for demo purposes
  redirectURL = 'http://portalshapefilegenerator.geodemosolutions.com'
 }
else {
  redirectURL = 'http://localhost:19002/'
}

export {
  redirectURL,
  mapURL
}
